export const ICON_1A = require('./2_icon1A.png'); 
export const ICON_1B = require('./2_icon1B.png'); 
export const ICON_2A = require('./2_icon2A.png'); 
export const ICON_2B = require('./2_icon2B.png'); 
export const ICON_3A = require('./2_icon3A.png'); 
export const ICON_3B = require('./2_icon3B.png'); 
export const ICON_4A = require('./2_icon4A.png'); 
export const ICON_4B = require('./2_icon4B.png'); 
export const ICON_5A = require('./2_icon5A.png'); 
export const ICON_5B = require('./2_icon5B.png'); 
export const ICON_6A = require('./2_icon6A.png'); 
export const ICON_6B = require('./2_icon6B.png'); 
export const CHARACTERS_1 = require('./3_001.png'); 
export const CHARACTERS_2 = require('./3_002.png'); 
export const CHARACTERS_3 = require('./3_003.png'); 
export const CHARACTERS_4 = require('./3_004.png'); 
export const CHARACTERS_5 = require('./3_005.png'); 
export const CHARACTERS_6 = require('./3_006.png'); 
export const ROAD = require('./road.png'); 
export const ARROW_DOWN = require('./arrow_down.png'); 
export const ARROW_UP = require('./arrow_up.png'); 
export const BOX_FRAME = require('./box_s.png'); 
export const BOX = require('./box.png'); 
export const TITLE = require('./3_title.png'); 

